import createReducer from 'utils/redux/createReducer'

const initialState = {
	showOmni: false
}

export default createReducer(initialState, {
  	SWITCH_OMNI: (currentState, action) => ({showOmni: !currentState.showOmni})
})



// WEBPACK FOOTER //
// ./src/reducers/mobileReducers.js